<template>
  <div>
    <v-select
      v-model="newselectedValueOption"
      :reduce="(user_options) => user_options.code"
      :options="user_options"
      :multiple="true"
      @search="fetchOptions"
      @input="selectedOption"
      :label="'name'"
    >
    </v-select>
  </div>
</template>
<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import UserService from '../../services/user.service';
var debounce = require('debounce');

export default {
  name: 'retailerMultiselect',
  props: ['remoteControl','preSelect'],
  components: { vSelect },
  mounted() {
    this.urlAppend = this.remoteControl;
    if(this.preSelect){
      this.newselectedValueOption = this.preSelect
    }    
  },
  data() {
    return {
      user_options: [],
      newselectedValueOption: {},
      urlAppend: 'bajajAPI/User/retailer',
    };
  },
  computed:{
    preSelectComputed:{
      get: function () {
        // return this.newselectedValueOption
      return this.preSelect
      },
      set: function (newValue) {
        // this.newselectedValue   = newValue
        var obj =[]
        for (var i=0; i < newValue.length; i++) {
          const result = this.user_options.find(val => val.code === newValue[i]);
          obj.push(result)
        }
        this.newselectedValueOption = obj
        // this.preSelect = result;
        this.$emit('selectedData', obj);
      }
    },},
  methods: {
    fetchOptions(search, loading) {
      if (search.length) {
        loading(true);
        this.searchVal(search, loading, this.urlAppend, this);
      }
    },
    searchVal: debounce((search, loading, url, vm) => {
      // var el = vm;
      // AJAX request
      var param = {};
      param.search = search;
      UserService.getMetod(url, param).then(function (response) {
        vm.user_options = response.data.user_data;
      });
      loading(false);
    }, 350),
    selectedOption(value) {
      this.preSelectComputed =value
    },
  },
  watch:{
   preSelect:function(newVal, oldVal){
    //  console.log('Prop changed: ', newVal, ' | was: ', oldVal)
     this.newselectedValueOption = this.preSelectComputed
   }
 },
};
</script>
